import { filter, length } from 'ramda'
import { useMemo } from 'react'

import { useReplies } from '../../_load/ServiceOrderLoader'

export const useActionPlansReplies = () => {
  const replies = useReplies()

  return useMemo(
    () =>
      filter(reply => {
        const type = reply.question?.type?.name
        return type === 'action_plan' && !!length(reply.value)
      }, replies || []),
    [replies]
  )
}
